import { toast } from '@/helpers/toast/toast.helper'
import { AxiosResponse } from 'axios'
import { put } from 'redux-saga/effects'
import { removeParticipantToGroupAction } from '../../handles'
import { zApiMultiService } from '@/services/api'
import { removeParticipant } from '../_http/groups'

export function* removeParticipantToGroupSaga(action: ReturnType<typeof removeParticipantToGroupAction.request>) {
  const { activeChat, phones, campaign, callBack } = action.payload
  try {
    const url = `/instances/campanhaId/${campaign.id}/token/${campaign.token}/remove-participant`
    const removeParticipantGroupResponse: AxiosResponse = yield zApiMultiService.post(url, {
      groupId: activeChat.phone,
      phones
    })

    if (removeParticipantGroupResponse.data?.value) {
      const { participants } = activeChat
      const updatedParticipants = participants.filter(participant => !phones.includes(participant.phone))
      for (const phone of phones) {
        yield removeParticipant(activeChat.id, phone, activeChat.ownerId)
      }
      toast({ type: 'success', message: `Contato removido com sucesso` })
      yield put(removeParticipantToGroupAction.success({ updatedChatData: { participants: updatedParticipants } }))
      callBack?.()
    } else {
      toast({ type: 'error', message: 'Não foi possível remover contato, tente novamente' })
      yield put(removeParticipantToGroupAction.failure(null))
    }
  } catch (error) {
    toast({ type: 'error', message: 'Erro ao remover contato do grupo' })
    console.log({ removeParticipantToGroupSagaError: error })
    yield put(removeParticipantToGroupAction.failure(error))
  }
}
